/**
 * AuditTabs — the strip shared by the two pages of the 管理 › 审计 entry: the
 * operations log and the data-change ledger. The tabs and their labels live in
 * `components/layout/nav-groups.ts` (`audit`). The v4 shell (#2476) had put
 * them on one strip with the three webhook views; the admin group split that
 * strip in two (`WebhooksTabs` in `features/webhooks` is the other half).
 *
 * The strip renders BENEATH the page title, through each resource's
 * `host.listTabs`. It used to sit above, which left each page titled after the
 * ACTIVE TAB and never naming the section. Same move as #2004 on the
 * operations inbox.
 *
 * It is navigation and nothing else. The two ledgers are routinely confused,
 * and each declares its own one-line description as its `listDescription`,
 * which `PageShell` paints as the page subtitle — directly under the title and
 * ABOVE this strip. Until 2026-08-08 the strip hung a two-row legend beneath
 * itself instead, which put the copy below the control it explains; the owner
 * moved it, and `AuditTabs.test.tsx` asserts the legend does not grow back.
 */
import { NavGroupTabs } from '@components/layout/NavGroupTabs';

export function AuditTabs() {
  return <NavGroupTabs group="audit" />;
}

export default AuditTabs;
